const COMPOSITE_CALENDAR_CONFIG = {
  HEADER_DATE_FORMAT: "dddd, DD MMM",
};

export default COMPOSITE_CALENDAR_CONFIG;
